<template>
  <image-box-tool-with-options
    v-if="show"
    ref="menu"
    v-bind="{
      title,
      icon,
      shadow: false,
      ...$attrs
    }"
  >
    <template #default>
      <color-picker-container
        :current-color="currentColor"
        @save="saveColor"
        @input="changeColor"
      />
    </template>
  </image-box-tool-with-options>
</template>
<script>
import ColorPickerContainer from '@/components/ColorPicker/ColorPickerContainer';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'BackgroundColorBoxTool',
  components: {
    ColorPickerContainer,
  },
  extends: ImageBoxTool,
  inheritAttrs: false,
  props: {
    fillColor: {
      type: String,
      default: 'transparent',
    },
    submenuValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      title: 'Background',
      icon: 'background',
      showLocal: true,
      currentColor: '',
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
    // showColors() {
    //   if (this.submenuValue === 'color') {
    //     return true;
    //   }
    //   return null;
    // },
  },
  watch: {
  },
  mounted() {
    this.$nextTick().then(() => {
      this.canvas.on('after:render', (e) => {
        this.currentColor = this.canvas.backgroundColor;
      });
    });
  },
  methods: {
    changeColor(color) {
      this.canvas.backgroundColor = color;
      this.canvas.renderAll();
      this.canvas.onHistory();
      this.$emit('selectColor', color);
    },
    saveColor(color) {
      // Closing menu
    //   this.$refs.menu.close();
      // We need to render the canvas to apply these changes
      //   this.canvas.renderAll();
      this.canvas.backgroundColor = color;
      this.canvas.renderAll();
    //   this.canvas.setBackgroundColor(color, () => {
    //     this.canvas.renderAll();
    //   });
    //   this.$emit('selectColor', color);
    //   this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
    },
  },
};
</script>
